import { gql } from "@apollo/client";

export const CLAIM_INVOICE = gql`
  mutation ClaimInvoice($invoiceId: uuid!) {
    claimInvoice: claim_invoice(invoice_id: $invoiceId) {
      invoice {
        id
        payer_account_id
        admin_fee_amount_waived
        is_fee_waived
        registered_vehicle {
          id
          invoices {
            id
            payer_account_id
            admin_fee_amount_waived
            is_fee_waived
            transactions {
              id
              account_id
            }
          }
        }
      }
    }
  }
`;

export interface ClaimInvoiceVars {
  invoiceId: string;
}

export interface ClaimInvoiceData {
  claimInvoice: {
    invoice: {
      id: string;
      payer_account_id: string;
      admin_fee_amount_waived: number;
      is_fee_waived: boolean;
      registered_vehicle: {
        id: string;
        invoices: {
          id: string;
          payer_account_id: string;
          admin_fee_amount_waived: number;
          is_fee_waived: boolean;
          transactions: {
            id: string;
            account_id: string;
          }[];
        }[];
      };
    } | null;
  };
}
